module.exports = __webpack_public_path__ + "img/Langham-text2.00e2a4ef.png";